// extracted by mini-css-extract-plugin
export default {"tariffs_table":"AcceptPartner_tariffs_table__KqogJ"};